export default __webpack_public_path__ + "static/yoga-app-e34ed29ba45be6c4db99a8b606441940.png";